import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  AccountsConfigurationKeys,
  ACCOUNTS_CONFIGURATIONS_DEFAULT_VALUES,
  ACCOUNTS_FEATURE_NAME,
} from '@epicuro-next/platform/configuration';
import { Account } from 'graphql-api/gql-api-interfaces';

@Component({
  selector: 'epc-account-details',
  templateUrl: './account-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AccountDetailsComponent {
  @Input() public account: Account;

  public showAccountIdsInNewLine =
    AccountsConfigurationKeys.ShowAccountIdsInNewLine;
  public accountsNamespace = ACCOUNTS_FEATURE_NAME;
  public defaultConfigValues = ACCOUNTS_CONFIGURATIONS_DEFAULT_VALUES;
}
